import { HamburgerIcon } from '@chakra-ui/icons';
import { Box, Flex, IconButton } from '@chakra-ui/react';
import { FC, memo } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { IndigoLogo } from '~/common/icons/IndigoLogo';
import { useMobileHeaderContext } from '../../contexts/MobileHeaderContext';
import { ProfilePicture } from '../User/ProfilePicture';
import { DefaultMobileNavDrawer } from './DefaultMobileNavDrawer';

export const MOBILE_HEADER_HEIGHT = '64px';

interface MobileHeaderProps {
  displayDefaultNav?: boolean;
  transparentMobileHeader?: boolean;
  tabletIsMobile?: boolean;
  hideProfileButton?: boolean; // hides the profile button on mobile
  centerComponent?: React.ReactNode; // replaces the logo on mobile
  stickyMobileHeader?: boolean;
}

export const MobileHeader: FC<MobileHeaderProps> = memo(
  ({
    displayDefaultNav,
    transparentMobileHeader,
    tabletIsMobile = false,
    hideProfileButton = false,
    centerComponent = undefined,
    stickyMobileHeader = false,
  }) => {
    const navigate = useNavigate();
    const { onDrawerOpen } = useMobileHeaderContext();

    const position = stickyMobileHeader
      ? 'sticky'
      : transparentMobileHeader
        ? 'absolute'
        : 'relative';

    const bg = transparentMobileHeader
      ? 'linear-gradient(180deg, rgba(0, 0, 0, 0.50) 0%, rgba(0, 0, 0, 0.25) 100%)'
      : stickyMobileHeader
        ? 'indigo.800'
        : 'transparent';

    return (
      <Flex
        backdropFilter={transparentMobileHeader ? 'blur(2px)' : undefined}
        background={bg}
        display={
          tabletIsMobile
            ? { base: 'flex', lg: 'none' }
            : { base: 'flex', md: 'none' }
        }
        justifyContent="space-between"
        position={position}
        px={4}
        py={4}
        top={0}
        width="100%"
        zIndex={transparentMobileHeader || stickyMobileHeader ? '5' : undefined}
      >
        <IconButton
          aria-label="Open menu"
          color="chakra-body-text"
          icon={<HamburgerIcon boxSize={8} />}
          variant="link"
          onClick={onDrawerOpen}
        />
        {centerComponent ? (
          centerComponent
        ) : (
          <NavLink to="/">
            <IndigoLogo />
          </NavLink>
        )}
        {!hideProfileButton ? (
          <ProfilePicture
            isEdit={false}
            size="sm"
            onClick={() => navigate('/account')}
          />
        ) : (
          !centerComponent && <Box width="32px" />
        )}
        {displayDefaultNav && <DefaultMobileNavDrawer />}
      </Flex>
    );
  }
);
